// extracted by mini-css-extract-plugin
module.exports = {"row":"_62cff9f0","item":"_cb6a6e0f","link":"_fb1985fa"};